import gql from 'graphql-tag';
import {
  lockerDeliveryFragment,
  paginationFragment,
  conciergeDeliveryFragment,
  porterDeliveryQrCodeFragment,
  deliveryUnityWithResponsiblesFragment,
  deliveryUnityEligiblePersonFragment,
  deliveryNotifiedPersonFragment,
} from './fragments';

export const lockerDeliveryHistory = gql`
  query lockerDeliveryHistory(
    $filters: FilterHistoryInput
    $condominiumPersonContextId: ID!
  ) {
    lockerDeliveryHistory(
      filters: $filters
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      collection {
        ...lockerDeliveryParts
      }
      pagination {
        ...paginationPartsForDelivery
      }
    }
  }
  ${lockerDeliveryFragment}
  ${paginationFragment}
`;

export const conciergeSettings = gql`
  query conciergeSettings($condominiumPersonContextId: ID!) {
    conciergeSettings(condominiumPersonContextId: $condominiumPersonContextId) {
      pickupSetting
      isCommercialBuilding
    }
  }
`;

export const conciergeDeliveries = gql`
  query conciergeDeliveries(
    $condominiumPersonContextId: ID!
    $status: [Int]
    $unityId: Int
    $trackingCode: String
    $page: Int
    $pageSize: Int
  ) {
    conciergeDeliveries(
      condominiumPersonContextId: $condominiumPersonContextId
      status: $status
      unityId: $unityId
      trackingCode: $trackingCode
      page: $page
      pageSize: $pageSize
    ) {
      collection {
        ...conciergeDeliveryParts
      }
      pagination {
        page
        pageSize
        hasNextPage
      }
    }
  }
  ${conciergeDeliveryFragment}
`;

export const conciergeDeliveriesPendingTotal = gql`
  query conciergeDeliveriesPendingTotal($condominiumPersonContextId: ID!) {
    conciergeDeliveriesPendingTotal(
      condominiumPersonContextId: $condominiumPersonContextId
    )
  }
`;

export const porterDeliveryEnabled = gql`
  query porterDeliveryEnabled($condominiumPersonContextId: ID!) {
    porterDeliveryEnabled(
      condominiumPersonContextId: $condominiumPersonContextId
    )
  }
`;

export const porterDeliveryQrCodes = gql`
  query porterDeliveryQrCodes($condominiumPersonContextId: ID!) {
    porterDeliveryQrCodes(
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      ...porterDeliveryQrCodeParts
    }
  }
  ${porterDeliveryQrCodeFragment}
`;

export const deliveryUnityResponsibles = gql`
  query deliveryUnityResponsibles(
    $condominiumPersonContextId: Int!
    $search: String
    $onlyWithoutResponsible: Boolean
    $page: Int
    $pageSize: Int
  ) {
    deliveryUnityResponsibles(
      condominiumPersonContextId: $condominiumPersonContextId
      search: $search
      onlyWithoutResponsible: $onlyWithoutResponsible
      page: $page
      pageSize: $pageSize
    ) {
      collection {
        ...deliveryUnityWithResponsiblesParts
      }
      pagination {
        page
        pageSize
        hasNextPage
      }
      summary {
        totalUnities
        unitiesWithoutResponsible
      }
    }
  }
  ${deliveryUnityWithResponsiblesFragment}
`;

export const deliveryUnityEligibleResponsibles = gql`
  query deliveryUnityEligibleResponsibles(
    $condominiumPersonContextId: Int!
    $unityId: Int!
  ) {
    deliveryUnityEligibleResponsibles(
      condominiumPersonContextId: $condominiumPersonContextId
      unityId: $unityId
    ) {
      ...deliveryUnityEligiblePersonParts
    }
  }
  ${deliveryUnityEligiblePersonFragment}
`;

export const deliveryNotificationRecipients = gql`
  query deliveryNotificationRecipients(
    $condominiumPersonContextId: Int!
    $unityId: Int!
    $deliveryKind: Int!
    $addresseePersonContextId: Int
  ) {
    deliveryNotificationRecipients(
      condominiumPersonContextId: $condominiumPersonContextId
      unityId: $unityId
      deliveryKind: $deliveryKind
      addresseePersonContextId: $addresseePersonContextId
    ) {
      mode
      recipients {
        ...deliveryNotifiedPersonParts
      }
    }
  }
  ${deliveryNotifiedPersonFragment}
`;
